(() => {
  let opener;
  function openAccessDialog(trigger) {
    const dialog = document.getElementById('hip-wholesale-dialog');
    if (!dialog) return;
    opener = trigger || document.activeElement;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      const link = dialog.querySelector('.hip-wholesale-login, .hip-wholesale-apply');
      if (link) window.location.assign(link.href);
    }
  }
  window.HiperionWholesale = { openAccessDialog };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-wholesale-open]');
    if (trigger) {
      // A normal link remains usable when JavaScript is unavailable.
      event.preventDefault();
      event.stopImmediatePropagation();
      openAccessDialog(trigger);
      return;
    }
    if (window.customerWholesaleApproved === true) return;
    const action = event.target.closest('.quick-view, .sca-qv-button, a[href*="/checkout"], [name="checkout"]');
    if (action) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openAccessDialog(action);
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || window.customerWholesaleApproved === true) return;
    if (form.getAttribute('method') === 'dialog') return;
    const path = new URL(form.action, window.location.href).pathname;
    const checkout = form.querySelector('[name="checkout"]');
    if (/\/cart(?:\/add(?:\.js)?|\/update(?:\.js)?)?\/?$/.test(path) || checkout) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openAccessDialog(event.submitter);
    }
  }, true);
  document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.getElementById('hip-wholesale-dialog');
    if (!dialog) return;
    dialog.addEventListener('close', () => {
      if (opener && opener.isConnected && typeof opener.focus === 'function') opener.focus();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  });
  // Do not retain an authenticated pricing page after sign-out/back navigation.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });
})();
